import { defineMessages } from 'react-intl-next';

export default defineMessages({
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    NoResultDescription: {
        defaultMessage: 'Please give us a rating above.',
        description: 'Request feedback description when there is no recorded rating yet.',
        id: 'cv.feedback.confirm.page.no.result.description',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    NoResultCommentLabel: {
        defaultMessage: "If you have a moment, we'd also love to hear your feedback on your experience with us.",
        description: 'Request feedback comment label when there is no recorded rating yet.',
        id: 'cv.feedback.confirm.page.comment.label.no.result',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    SadFaceDescription: {
        defaultMessage: 'Sorry to hear that.',
        description: 'Request feedback description when there is a 1 or 2 star rating.',
        id: 'cv.feedback.confirm.page.sad.face.description',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    SadFaceCommentLabel: {
        defaultMessage: 'If you have a moment, tell us how it went so we can do better next time.',
        description: 'Request feedback comment label when is a 1 or 2 star rating.',
        id: 'cv.feedback.confirm.page.comment.label.sad',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    NeutralFaceDescription: {
        defaultMessage: 'Thanks! We got it.',
        description: 'Request feedback description when there is a 3 star rating.',
        id: 'cv.feedback.confirm.page.neutral.face.description',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    HappyFaceDescription: {
        defaultMessage: 'Awesome! We got it.',
        description: 'Request feedback description when there is a 4 or 5 star rating.',
        id: 'cv.feedback.confirm.page.happy.face.description',
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    HappyFaceCommentLabel: {
        defaultMessage: 'If you have a moment, tell us how it went so we can keep it up!',
        description: 'Request feedback comment label when is a 4 or 5 star rating.',
        id: 'cv.feedback.confirm.page.comment.label.happy',
    },
});
